import { MatchFormSubmitter } from '@se-po/se-household-setup-feature-match'

export class DocsMatchSubmitter implements MatchFormSubmitter {
  public submitting = false

  signIn(formEl: HTMLFormElement): void {
    console.log('formEl', formEl)
    alert('This will submit to the sign in page with the selected email prefilled')
    this.submitting = false
  }

  noMatch(): void {
    alert('This will navigate the user to store.nextPath')
    this.submitting = false
  }

  reset(): void {
    alert('This will direct back to account')
    this.submitting = false
  }
}
